<template>
  <div class="component">
    <vue-headful
    title="Methods List | W&S Docs"
    />
    <div class="loading" v-if="loading">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div class="alert alert-success text-success font-weight-bold" role="alert" v-if="result">
      Успешно удалено!
    </div>

    <div class="form-group">
      <router-link class="btn bg-dark text-white" to="/admin/Methods/add">Добавить метод</router-link>
    </div>

    <ul class="list-group list-group-flush">
      <li :key="index"
      class="list-group-item bg-dark d-flex align-items-center justify-content-between" v-for="(method, index) in AllMethodsGet">
      <div class="form-group m-0">
        <router-link :to="'/methods/' +  method.method_link">{{ method.method_link }}</router-link>
      </div>
      <div class="form-group m-0">
        <router-link :to="'/admin/Methods/edit/' + method.method_link" class="btn p-1" title="Edit">
          <i class="far fa-edit"></i>
        </router-link>
        <span @click="deleteMethod(index, method.method_id)" class="btn p-1" title="Delete">
          <i class="fas fa-times-circle"></i>
        </span>
      </div>
    </li>
  </ul>
</div>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    name: "MethodsList",
    data() {
      return {
        loading: true,
        result: false
      }
    },
    computed: mapGetters(['AllMethodsGet', 'MethodErrorGet', 'MethodSuccessGet', 'AdminAuthInfoGet']),
    mounted() {
      this.$store.dispatch('AllMethodsAct');
      this.loading = false;
    },
    methods: {
      deleteMethod: function (index, Method_id) {
        let AdminID = this.AdminAuthInfoGet.AdminID,
        AdminToken = this.AdminAuthInfoGet.AdminToken;

        this.$store.dispatch('MethodStatusAct', [Method_id, 1, AdminID, AdminToken]);

        if (this.MethodSuccessGet === true && this.MethodErrorGet.length === 0) {
          this.result = true;
          this.$store.dispatch('AllMethodsAct');
          this.$store.getters.AllMethodsGet;
        }
      },
    }
  }
</script>

<style scoped>

</style>
